import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp, commonData } from "@/mixins/index";
export default {
  mixins: [popUp, commonData],
  data: function data() {
    var validateNum = function validateNum(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入'));
      } else {
        if (!/^(0(\.\d{1,4})?|1(\.0{1,4})?)$/.test(value)) {
          callback(new Error('请输入0-1且最多保留4位小数的数字'));
        }

        callback();
      }
    };

    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        appid: "",
        payment_type_id: "",
        product: "",
        third_part_product: "",
        price: "",
        // pay_price: "",
        discount: "",
        currency: "",
        product_name: ""
      },
      rules: {
        appid: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        payment_type_id: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        product: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        third_part_product: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        third_part_price: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        price: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        discount: [{
          required: true,
          validator: validateNum,
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getcommonData(['appListAllData', 'appPaymentTypeAllData']);

              case 2:
                _this.copyPrimitive();

                if (data) {
                  _this.formData = _objectSpread({}, data);
                }

                _this.copyData();

                _this.dialogFormVisible = true;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var reqFn = _this2.formData.id ? 'appPaymentGoodsUpdate' : 'appPaymentGoodsAdd';

          _this2.$api[reqFn](_objectSpread(_objectSpread({}, _this2.formData), {}, {
            isMustAppid: 1
          })).then(function (res) {
            if (res.status == 200) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.dialogFormVisible = false;

              _this2.$emit('change');
            }
          });
        }
      });
    }
  }
};